



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import debounce from 'debounce';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { IField } from '@/dealroom/fields/types/field';
import { EValidationStatus } from '@/dealroom/types/enums/validation-status';
import { validateRegex } from '@/helpers/validation.helper';
import { EValidationRegex } from '@/enums/ValidationRegex';
import FieldSettingsContainer from '@/dealroom/fields/context-menu/components/FieldSettingsContainer.vue';
import Checkbox from '@/components/Checkbox.vue';

@Component({
  components: {
    Input,
    Button,
    FieldSettingsContainer,
    Checkbox,
  },
  data: () => ({
    EValidationStatus,
  }),
})
export default class LinkFieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() height: string;
  @Prop() isTemplate: boolean;

  validationStatus: EValidationStatus = EValidationStatus.None;
  urlMinimumLimit = 5;
  url: string = this.field.value;
  isEditable: boolean = this.field.isEditable;

  debounceValidation: (newValue: string, _: string) => void = debounce(
    this.validateContentLink,
    300
  );

  @Watch('url')
  watchUrl(newUrl: string, _: string) {
    this.debounceValidation(newUrl, _);
  }

  handleIsEditable(value: boolean) {
    this.isEditable = value;
  }

  handleInput(payload: string) {
    this.url = payload;
  }

  handleUpdate() {
    const payload: Partial<IField> = { value: this.url, isEditable: this.isEditable };
    this.$emit('update', payload);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleUpdate();
    }
  }

  validateContentLink(newUrl: string) {
    this.verifyContentLinkUrl(newUrl);
  }

  verifyContentLinkUrl(url: string) {
    if (!!url && validateRegex(EValidationRegex.Website, url)) {
      this.validationStatus = EValidationStatus.Valid;
      return;
    }
    this.validationStatus = EValidationStatus.Invalid;
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
